import VWave from 'v-wave'
// 加载 iconify 图标
import { downloadAndInstall } from '@/iconify'
import icons from '@/iconify/index.json'
// 自定义指令
import directive from '@/utils/directive'
// 错误日志上报
import errorLog from '@/utils/errorLog'
// 企业微信工具
import { isWecomEnvironment, registerWecomJsSDK } from '@/utils/wecom'
import App from './App.vue'

import i18n from './locales'
import router from './router'
import pinia from './store'
import uiProvider from './ui/provider'
// 自定义样式
import '@/assets/styles/custom.css'
import '@/utils/storage'
import '@/utils/systemCopyright'

// 加载 svg 图标
import 'virtual:svg-icons-register'
// UnoCSS
import '@unocss/reset/tailwind-compat.css'
import 'virtual:uno.css'
// 全局样式
import '@/assets/styles/globals.css'

const app = createApp(App)
app.use(VWave, {})
app.use(pinia)
app.use(router)
app.use(uiProvider)
app.use(i18n)
directive(app)
errorLog(app)
if (icons.isOfflineUse) {
  for (const info of icons.collections) {
    downloadAndInstall(info)
  }
}

// 如果在企业微信环境中，自动注册 JS-SDK
if (isWecomEnvironment()) {
  registerWecomJsSDK().catch((err) => {
    console.warn('企业微信 JS-SDK 自动注册失败:', err)
  })
}

app.mount('#app')
